import { DynamicIconType, FieldTypeLink } from '@allesauto/utils/consts';
import { getUrlFromStoryblokLink } from '@allesauto/utils/funcs';
import clsx from 'clsx';
import React from 'react';

import DynamicIcon from '../../dynamicIcon';
import NextLink from '../../nextLink';

export interface ISocialMediaItem {
  _uid: string;
  title: string;
  description?: string;
  icon: DynamicIconType;
  link: FieldTypeLink;
}

export interface ISocialMediaProps {
  item: ISocialMediaItem;
  itemsLength?: number;
}

export default function SocialMediaItem({
  item: { title, icon, description, link },
  itemsLength,
}: ISocialMediaProps) {
  const url = getUrlFromStoryblokLink(link);

  const withIcon = !!url && !!title && !!icon;

  const className = {
    container: clsx(
      'flex py-20px relative',
      itemsLength && itemsLength <= 4 ? `md:w-1/${itemsLength}` : `md:w-1/4`
    ),
  };

  if (!withIcon) {
    return null;
  }

  return (
    <div className={className.container}>
      <NextLink
        href={url}
        passHref
        target={link.target}
        className="mb-20px no-underline py-20px relative sm:h-[100px] lg:h-[212px]"
      >
        <DynamicIcon
          icon={icon as DynamicIconType}
          customClassName="absolute text-green60 top-0 w-auto sm:!h-40px lg:!h-60px"
        />
        <h3 className="absolute bottom-0">{title}</h3>
      </NextLink>
      <p className="absolute bottom-0">{description}</p>
    </div>
  );
}
